import { createApi } from '@reduxjs/toolkit/query/react';

import { apiWeeklyPlannerAppointmentUnallocated } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import { UnallocatedAppointment } from '~weekly-planner/lib/common';

import { typePrefix as prefix } from '~weekly-planner/actions/appointments';

export const typePrefix = `${prefix}-unallocated`;

export type UnallocatedReq = {
  limit?: number;
  week_start?: string;
  [key: string]: unknown;
};

export type UnallocatedResp = {
  count: number;
  rows: UnallocatedAppointment[];
  total: number;
};

export const unallocatedApi = createApi({
  reducerPath: 'weeklyPlannerUnallocatedApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiWeeklyPlannerAppointmentUnallocated }),
  tagTypes: ['unallocated', 'unallocated-assignable'],
  endpoints: (builder) => ({
    getUnallocated: builder.query<UnallocatedResp, UnallocatedReq | void>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'unallocated', id: 'LIST' }],
      transformResponse: (payload) => unwrap<UnallocatedResp>(payload),
    }),
    getUnallocatedAssignable: builder.query<UnallocatedAppointment[], UnallocatedReq | void>({
      query: (params) => ({ url: '/assignable', method: 'GET', params }),
      providesTags: [{ type: 'unallocated-assignable', id: 'LIST' }],
      transformResponse: (payload) => unwrap<UnallocatedAppointment[]>(payload),
    }),
  }),
});

export const { useGetUnallocatedQuery, useLazyGetUnallocatedQuery, useLazyGetUnallocatedAssignableQuery } =
  unallocatedApi;
